<template>
  <router-view v-slot="{ Component }">
    <!-- <transition :name="$route.meta.isHideMenu ? '' : 'fade'" name="fade" mode="out-in"> -->
      <keep-alive :include="keepAliveRouterName">
        <component :is="Component" />
      </keep-alive>
    <!-- </transition> -->
  </router-view>
</template>

<script setup>
import { keepAliveRouterName } from '@/router/router.config'

</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.2s ease;
  /* 设置进入和离开时的过渡时间为 0.2s */
}

.fade-leave-active {
  transition: all 0.2s ease;
  /* 设置离开时的过渡时间为 0.2s */
}

.fade-enter-from {
  opacity: 0;
  /* 初始透明度为 0 */
  transform: scale(0.9);
  /* 初始缩放为 0.9（从小到大） */
}

.fade-leave-to {
  opacity: 0;
  /* 离开时透明度为 0 */
  transform: scale(0.9);
  /* 离开时缩小（从大到小） */
}

/* 可选的：定义其他动画效果 */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.5s;
}

.slide-right-enter,
.slide-right-leave-to {
  // transform: translateX(100%);
  transform: scale(0);
}

.content-enter-active {
  transition: all 0.25s linear;
}

.content-enter-from {
  opacity: 0;
  transform: scale(0.95);
}
</style>
